import lazyLoadOnRender from '../../lazy/loadOnRender';

const NavigationCommunitiesBoundary = () =>
  import(/* webpackChunkName: "4-feat-navigationcommunities" */ './NavigationCommunitiesBoundary');

const LoadableNavigationCommunities = lazyLoadOnRender({ loader: NavigationCommunitiesBoundary });

export default LoadableNavigationCommunities;
